/*
 * バナーカルーセル
 * - 中央のスライドの前後が見える（CSS の scroll-snap で中央に吸着）
 * - 先頭と末尾に複製スライドを置き、複製に止まったら同じ本物の位置へ瞬間移動してループさせる
 */
if (!customElements.get('banner-carousel')) {
  class BannerCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.slides = Array.from(this.querySelectorAll('.banner-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.realSlides = this.slides.filter((slide) => !slide.hasAttribute('data-clone'));
      if (!this.viewport || this.realSlides.length === 0) return;

      this.current = 0;
      this.paused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.jumpTo(this.realSlides[0]);
      window.requestAnimationFrame(() => this.jumpTo(this.realSlides[0]));

      if (this.realSlides.length < 2) return;

      this.viewport.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) =>
        dot.addEventListener('click', () => this.goTo(this.realSlides[Number(dot.dataset.dot)], true))
      );

      ['mouseenter', 'focusin', 'touchstart'].forEach((type) =>
        this.addEventListener(type, () => (this.paused = true), { passive: true })
      );
      ['mouseleave', 'focusout', 'touchend'].forEach((type) =>
        this.addEventListener(type, () => (this.paused = false), { passive: true })
      );

      this.resizeObserver = new ResizeObserver(() => this.jumpTo(this.realSlides[this.current]));
      this.resizeObserver.observe(this.viewport);

      if (this.dataset.autoplay === 'true' && !this.reducedMotion && !window.Shopify?.designMode) {
        const interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;
        this.timer = window.setInterval(() => {
          if (!this.paused && !document.hidden) this.step(1);
        }, interval);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.resizeObserver?.disconnect();
    }

    offsetFor(slide) {
      return slide.offsetLeft + slide.offsetWidth / 2 - this.viewport.clientWidth / 2;
    }

    jumpTo(slide) {
      if (!slide) return;
      this.viewport.scrollTo({ left: this.offsetFor(slide), behavior: 'instant' });
    }

    goTo(slide, smooth) {
      if (!slide) return;
      this.viewport.scrollTo({
        left: this.offsetFor(slide),
        behavior: smooth && !this.reducedMotion ? 'smooth' : 'instant',
      });
    }

    nearestSlide() {
      const center = this.viewport.scrollLeft + this.viewport.clientWidth / 2;
      let nearest = this.slides[0];
      let best = Infinity;
      this.slides.forEach((slide) => {
        const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (distance < best) {
          best = distance;
          nearest = slide;
        }
      });
      return nearest;
    }

    step(direction) {
      const index = this.slides.indexOf(this.nearestSlide());
      this.goTo(this.slides[index + direction], true);
    }

    onScroll() {
      const slide = this.nearestSlide();
      this.current = Number(slide.dataset.index) || 0;
      this.dots.forEach((dot, i) => dot.toggleAttribute('aria-current', i === this.current));

      // スクロールが止まってから、複製の上にいれば本物の位置へ瞬間移動する
      window.clearTimeout(this.settleTimer);
      this.settleTimer = window.setTimeout(() => {
        const settled = this.nearestSlide();
        if (settled.hasAttribute('data-clone')) {
          this.jumpTo(this.realSlides[Number(settled.dataset.index)]);
        }
      }, 140);
    }
  }

  customElements.define('banner-carousel', BannerCarousel);
}
